import { useEffect } from "react";

import { Button, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { RouteLinks } from "services/router.service";
import phoneIcon from "data/icons/phone.svg";
import { formatPhoneNumber } from "services/data.service";
import api from "services/api.service";
import { useAppSelector } from "store";
import { getContractorsSelector } from "store/contractors/contractors.selector";
import { getContractors } from "store/contractors/contractors.thunks";

import "./ContractorForm.scss";

const initialValues = {
  default_email: "",
  name: "",
  official_name: "",
  phone_number: "",
};

interface IProps {
  onClose?: () => void;
  contractorId?: string;
}

const ContractorForm = ({ onClose, contractorId }: IProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { currentContractor } = useAppSelector(getContractorsSelector);

  const [ form ] = Form.useForm();

  const handleCompleteForm = async (values: any) => {
    try {
      if (contractorId) {
        await api.editContractor({
          id: Number(contractorId),
          ...values,
        });
      } else {
        await api.addContractor(values);

        // @ts-ignore
        dispatch(getContractors());
      }

      navigate(RouteLinks.PROTECTED.CONTRACTORS.LIST);
    } catch (e: any) {
      message.error(e.response.data.error || e.error || "Something went wrong!");
    }

    onClose?.();
    form.setFieldsValue(initialValues);
  }

  useEffect(() => {
    if (contractorId && currentContractor) {
      form.setFieldsValue({
        ...currentContractor,
        phone_number: formatPhoneNumber(currentContractor.phone_number || ""),
      });
    }

    return () => {
      form.setFieldsValue(initialValues);
    }
  }, [ currentContractor ]);

  return (
    <Form
      className="contractor-form"
      layout="vertical"
      form={ form }
      onFinish={ handleCompleteForm }
    >
      {contractorId && (
        <Form.Item
          label="Default email"
          name="default_email"
          rules={ [ { required: true, message: "Please input default email!" } ] }
        >
          <Input />
        </Form.Item>
      )}

      <Form.Item
        label="Name"
        name="name"
        rules={ [ { required: true, message: "Please input name!" } ] }
      >
        <Input 
          placeholder="e.g. ПолНочь"
        />
      </Form.Item>

      <Form.Item
        label="Official name"
        name="official_name"
        rules={ [ { required: true, message: "Please input official name!" } ] }
      >
        <Input 
          placeholder="e.g. ООО 'Полярная Ночь'"
        />
      </Form.Item>

      {contractorId && (
        <Form.Item
          label="Phone number"
          name="phone_number"
        >
          <Input
            placeholder="+375 (00) 000-00-00"
            prefix={ <img src={ phoneIcon } alt="" style={ { marginRight: "5px" } } /> }
            onChange={ (e) => form.setFieldsValue({ phone_number: formatPhoneNumber(e.target.value) }) }
          />
        </Form.Item>
      )}

      <div className="buttons-wrapper">
        <Button
          htmlType="submit"
          type="primary"
        >
          Save
        </Button>

        <Button
          onClick={ () => {
            navigate(RouteLinks.PROTECTED.CONTRACTORS.LIST);
            onClose?.();
          } }
        >
          Cancel
        </Button>
      </div>
    </Form>
  );
};

export default ContractorForm;
